import { HelmetDatoCms } from "gatsby-source-datocms";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";

export const FaviconMetaTag = (props) => {
  const locale = props.locale;
  const data = useStaticQuery(graphql`
    query {
      site: datoCmsSite {
        faviconMetaTags {
          tags
        }
      }
    }
  `);

  return (
    <HelmetDatoCms
      favicon={data.site.faviconMetaTags}
      htmlAttributes={{
        lang: locale
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, minimum-scale=1.0, maximum-scale=5.0"
      />
    </HelmetDatoCms>
  );
};
